import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { StorageService } from '../services/storage.service';
import StorageKeys from '../constants/storage';

@Injectable({
  providedIn: 'root'
})
export class DataRequiredGuard implements CanActivate {
  private storageService = inject(StorageService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const url = state.url;

    // Check required data based on the route
    if (url.includes('/meter-confirmation') || url.includes('/meter-review')) {
      // For meter routes, check if fuel type is selected
      const energyType = this.storageService.getItemFromSessionStorage(StorageKeys.SELECTED_ENERGY_TYPE);
      if (!energyType) {
        this.router.navigate(['/']);
        return false;
      }
    }

    if (url.includes('/quotes') || url.includes('/generate-quote')) {
      // For quotes, check if address and meter are selected
      const selectedAddress = this.storageService.getItemFromSessionStorage(StorageKeys.SELECTED_ADDRESS);
      const selectedMeter = this.storageService.getItemFromSessionStorage(StorageKeys.SELECTED_METER);

      if (!selectedAddress || !selectedMeter) {
        this.router.navigate(['/']);
        return false;
      }
    }

    if (url.includes('/business-details')) {
      // For business details, check if quote is selected
      const selectedQuote = this.storageService.getItemFromSessionStorage(StorageKeys.SELECTED_QUOTE);
      const selectedAddress = this.storageService.getItemFromSessionStorage(StorageKeys.SELECTED_ADDRESS);
      const selectedMeter = this.storageService.getItemFromSessionStorage(StorageKeys.SELECTED_METER);

      if (!selectedQuote || !selectedAddress || !selectedMeter) {
        this.router.navigate(['/']);
        return false;
      }
    }

    if (url.includes('/application-review')) {
      // For application review, check if all required data is present
      const selectedAddress = this.storageService.getItemFromSessionStorage(StorageKeys.SELECTED_ADDRESS);
      const selectedMeter = this.storageService.getItemFromSessionStorage(StorageKeys.SELECTED_METER);
      const selectedQuote = this.storageService.getItemFromSessionStorage(StorageKeys.SELECTED_QUOTE);

      if (!selectedAddress || !selectedMeter || !selectedQuote) {
        this.router.navigate(['/']);
        return false;
      }
    }

    if (url.includes('/contact-details')) {
      // For contact details, check if basic flow data exists
      const selectedAddress = this.storageService.getItemFromSessionStorage(StorageKeys.SELECTED_ADDRESS);
      const selectedMeter = this.storageService.getItemFromSessionStorage(StorageKeys.SELECTED_METER);

      if (!selectedAddress || !selectedMeter) {
        this.router.navigate(['/']);
        return false;
      }
    }

    if (url.includes('/switch-confirmation')) {
      // For switch confirmation, all data should be present
      const selectedAddress = this.storageService.getItemFromSessionStorage(StorageKeys.SELECTED_ADDRESS);
      const selectedMeter = this.storageService.getItemFromSessionStorage(StorageKeys.SELECTED_METER);
      const selectedQuote = this.storageService.getItemFromSessionStorage(StorageKeys.SELECTED_QUOTE);

      if (!selectedAddress || !selectedMeter || !selectedQuote) {
        this.router.navigate(['/']);
        return false;
      }
    }

    return true;
  }
}
